angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\"\n" +
    "    ng-click=\"select($event)\"\n" +
    "    aria-selected=\"{{active ? true : false}}\"\n" +
    "    id=\"{{getUniqueId()}}\"\n" +
    "    aria-controls=\"{{getTabPaneId()}}\"\n" +
    "    class=\"uib-tab nav-item\"\n" +
    "    tabindex=\"{{active ? 0 : -1}}\"\n" +
    ">\n" +
    "  <a tabindex=\"-1\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);
